import { tv } from 'tailwind-variants';

const leftChecked = 'checked:after:left-[calc(100%-26px)]';
const leftCheckedCustom = 'checked:after:left-[calc(100%-32px)]';
const beforeContent = 'before:content-[attr(placeholder)]';
const beforeUnchecked = 'before:translate-x-[calc(100%-32px)]';

const inputStyle = tv({
  base: `peer relative flex flex-1 items-center h-6 w-full cursor-pointer appearance-none rounded-full transition-colors bg-opacity-20 after:absolute after:shadow-sm after:left-2 after:h-[18px] after:w-[18px] after:rounded-full after:transition-all hover:bg-opacity-30 checked:bg-opacity-20 checked:hover:bg-opacity-30`,
  variants: {
    design: {
      primary: `bg-red-700 after:bg-red-700 checked:bg-emerald-700 checked:after:bg-emerald-700 ${leftChecked} focus:outline-none focus-visible:outline-none`,
      custom: `bg-red-700 after:rounded-md after:h-6 after:w-6 after:bg-red-700 after:text-white after:flex after:justify-center after:items-center after:font-bold after:text-sm after:content-['✗'] checked:bg-emerald-700 checked:after:bg-emerald-700 checked:after:content-['✓'] ${leftCheckedCustom}`,
    },
    beforeContent: {
      true: `h-10 rounded-none before:w-full before:transition-all before:duration-500 ${beforeUnchecked} before:checked:translate-x-4 before:text-sm before:font-semibold ${beforeContent}`,
    },
    errored: {
      true: 'border-primary-two',
    },
    disabled: {
      true: 'disabled:cursor-not-allowed disabled:border-slate-100',
    },
  },
  defaultVariants: {
    design: 'primary',
  },
  compoundVariants: [
    {
      design: 'primary',
      beforeContent: true,
      className: 'before:text-red-700 before:checked:text-emerald-700',
    },
    {
      design: 'custom',
      beforeContent: true,
      className: 'before:text-red-700 before:checked:text-emerald-700',
    },
  ],
});

const labelStyle = tv({
  base: 'cursor-pointer pr-2 peer-disabled:cursor-not-allowed peer-disabled:text-slate-400',
  variants: {
    design: {
      primary: 'text-secondary-two',
      admin: 'text-secondary-one',
    },
    errored: {
      true: 'text-primary-two',
    },
    disabled: {
      true: 'peer-disabled:cursor-not-allowed peer-disabled:text-slate-400 read-only:cursor-not-allowed read-only:text-slate-400',
    },
  },
  defaultVariants: {
    design: 'primary',
  },
});

export const switchStyles = {
  input: inputStyle,
  label: labelStyle,
};
